import { types as rs } from 'src/apis/types';

export interface IViewMenuItem extends rs.OrderItem {
  quantity: number;
}

export enum ELoadOrderStatus {
  'Pending' = 'pending',
  'Error' = 'error',
}
